<template>
    <div :class="active ? 'block' : 'hidden'">
        <div class="fixed z-50 pin overflow-hidden bg-modal" @click.prevent="close"></div>
        <button type="button" @click.prevent="close" class="z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2">
            <span class="icon"><i class="mdi mdi-close"></i></span>
        </button>
        <div class="fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4">
            <div class="bg-primary rounded shadow">
                <div class="p-6">
                    <div class="text-center mb-4">
                        <img src="/static/img/login_img.png" alt="Tooddoc Logo" class="h-48">
                    </div>

                    <div class="block bg-red rounded text-white mb-6" v-if="$store.state.formError">
                        <div class="flex items-center">
                            <span class="icon"><i class="mdi mdi-alert"></i></span>
                            <div>
                                <p v-text="$store.state.formError"></p>
                            </div>
                        </div>
                    </div>

                    <div class="text-center" v-show="! terms_accepted">
                        <label class="block mb-4 text-white text-center">
                            <span class="text-sm font-semibold ml-1 text-white" v-html="$t('By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy', {termsUri: $t('terms_uri'), privacyUri: $t('privacy_policy_uri')})"></span>
                        </label>
                        <button type="button" class="flex items-center justify-center rounded bg-blue-dark hover:bg-blue-darker text-white px-4 py-2 w-full" @click.prevent="acceptTerms()">
                            {{ $t('Continue') }}
                        </button>
                    </div>

                    <div v-show="terms_accepted">
                        <div id="firebaseui-auth-container" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebaseui from 'firebaseui'
import { auth, authProviders } from '@/firebase'
import { store } from '@/store'
import patientRepository from '@/data/PatientRepository'

export default {
    name: 'login-modal',

    props: ['active'],

    data: () => ({
        terms_accepted: false
    }),

    methods: {
        close () {
            this.$emit('close')
        },

        acceptTerms () {
            this.terms_accepted = true
            this.loadFirebaseUi()
        },

        loadFirebaseUi () {
            let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth)

            ui.start('#firebaseui-auth-container', {
                signInOptions: [
                    authProviders.Email,
                    authProviders.Google,
                    authProviders.Facebook,
                ],
                signInFlow: 'popup',
                credentialHelper: firebaseui.auth.CredentialHelper.NONE,
                callbacks: {
                    signInSuccessWithAuthResult: (result) => {
                        if (result && result.user) {
                            // Patient does not exist
                            patientRepository.createOrUpdate(result.user, (patient) => {
                                store.dispatch('setPatient', patient)
                                window.location.reload()
                            }, (error) => {
                                // Could not create patient
                                console.error(error)
                            })
                        }
                    }
                }
            })
        }
    }
}
</script>

<style src="@/../node_modules/firebaseui/dist/firebaseui.css"></style>



// WEBPACK FOOTER //
// src/components/Patient/LoginModal.vue